import React from 'react'

const Loader = () => {
    return (
        <div className="loader-container-spinner">
           <div className="loader-spinner"></div> 
        </div>
    )
}

export default Loader
